export const employeeTableHeaders = (staticData, isAdmin, isAdd = false) => {
  const roles = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "role").map((x) => ({
      value: x.id,
      label: x.description,
    })),
  ];

  const band = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "band").map((x) => ({
      value: x.id,
      label: x.description,
    })),
  ];

  const competency = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "competency").map((x) => ({
      value: x.description,
      label: x.description,
    })),
  ];

  const team = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "team").map((x) => ({
      value: x.id,
      label: x.description,
    })),
  ];

  const geography = [
    { value: "", label: "Select" },
    { value: "India", label: "India" },
    { value: "Canada", label: "Canada" },
    { value: "US", label: "US" },
  ];

  return [
    { title: "Emp ID", accessor: "employee_id", isRequired: true },
    { title: "Employee Name", accessor: "employee_name", isRequired: true },
    { title: "Email ID", accessor: "email_id", isRequired: true },
    { title: "Competency", accessor: "competency", type: "combo", valueList: competency },
    { title: "Band", accessor: "band_type", type: "combo", valueList: band },
    { title: "Team", accessor: "team", type: "combo", valueList: team },   // ✅ NEW COLUMN
    { title: "Geography", accessor: "geography", type: "combo", valueList: geography },
    { title: "Role", accessor: "role_name", isRequired: true, type: "combo", valueList: roles },
    { title: "Joining Date", accessor: "joining_date", isRequired: true, type: "date", className: "joining-date-col" },
    { title: "Skill Set", accessor: "skill_set", isRequired: true },
    { title: "Secondary Skill Set", accessor: "sec_skill_set" },
    ...(isAdmin ? [
      { title: "", accessor: "edit" },  
      { title: "", accessor: "delete" }
    ] : []),
  ];
};
